import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlContainer,
  FormGroupDirective,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { FormInputComponent } from '../form-input.component';
import { ToFormControlPipe } from '../../../../pipes/to-form-control/to-form-control.pipe';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { QuillEditorComponent } from 'ngx-quill';

@Component({
  selector: 'aw-text-editor',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ErrorMessageComponent,
    ToFormControlPipe,
    AppendTestIdPipe,
    QuillEditorComponent,
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  templateUrl: './text-editor.component.html',
})
export class TextEditorComponent extends FormInputComponent {
  public readonly editorModules = {
    toolbar: [['bold', 'italic', 'underline'], [{ list: 'bullet' }]],
  };
  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }
}
